import { formatDate } from "@ui-seeker/utils"


export default function dateColumn() {
    return {
        name: "date", label: 'Date',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: value => formatDate(value, { isString: true})
        }
    }
}